import { useEffect, useState, useContext } from "react";
import toast from "react-hot-toast";
import PaymentTable from "../../payments/components/ClientDetailsPaymentList";
import { getAllClients } from "api/clients";
import { ClientContext } from "ClientProvider";
import { getSingleRole } from "api/graphQL_role";
import { getAllGatewaysSecond } from "api/graphQL_gateways";
import { getCardType, getClientPaymentsFilter } from "api/graphQL_payments";
import { getId } from "utils/auth";

export type PaymentRowObj = {
  id: any;
  payment_id: string;
  et_id: string;
  reference_id:string;
  amount: string;
  currency: string;
  gateway_id: string;
  gateway_name: string;
  status: string;
  meta_info: any;
  payment_type: string;
  client: string;
  refund_info: string;
  created_at: string;
  image: string;
  all_data: any[];
  expanded: boolean;
  payment_history: any;
  gateway_response: any;
  card_type: any;
  customer_name: any;
};

const Payments = (props:{client_id:any}) => {
    const { client_id } = props;

    const [payments, setPayments] = useState<PaymentRowObj[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>();
    const [isPaymentLoading, setIsPaymentLoading] = useState<boolean>();
    const [page, setPage] = useState<number>(0);
    const [totalpage, setTotalPage] = useState<number>(0);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(50);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [clients, setClients] = useState();
    const [value, setValue] = useState(false);
    const [curretClient, setCurrentClient] = useState<string>("all");
    const [allGateways, setAllGateways] = useState();
    const [allCardType, setCardType] = useState();
    const [searchTexts, setSearchTexts] = useState<string>("");
    const [localFilters, setLocalFilters] = useState<any>({});
    const [clearClicked, setClearClick] = useState(0);
    const { paymentType, singleRoleData, setSingleRoleData, setFilter, filter, setLoadingTransaction } = useContext(ClientContext);
    const [loadingState, setLoadingState] = useState({ clients: true, gateways: true, cardTypes: true });

  useEffect(() => { setFilter({}); }, []);

  const fetchClients = () => {
    setIsLoading(true);
    getAllClients(0)
      .then((data) => setClients(data))
      .catch((err) => toast.error(err?.response?.data?.message ?? "Something went wrong while fetching clients"))
      .finally(() => { setIsLoading(false); setLoadingState((p) => ({ ...p, clients: false })); });
  };

  const fetchAllGateways = () => {
    getAllGatewaysSecond()
      .then((data) => setAllGateways(data))
      .catch(() => {})
      .finally(() => setLoadingState((p) => ({ ...p, gateways: false })));
  };

  const fetchCardType = () => {
    getCardType()
      .then((data) => setCardType(data))
      .catch(() => {})
      .finally(() => setLoadingState((p) => ({ ...p, cardTypes: false })));
  };

  useEffect(() => { fetchClients(); fetchAllGateways(); fetchCardType(); }, []);

  const serchboxValueChange = async (searchTerm: string) => {
    const search_txt = searchTerm || "";
    if (search_txt !== searchTexts && searchTexts !== "") {
      await setSearchTexts(search_txt); setPage(1);
    } else {
      await setSearchTexts(search_txt);
    }
  };

  const filterData = async () => {
    setIsPaymentLoading(true);
    setPayments([]);
    setLoadingTransaction(true);
    try {
      const data = await getClientPaymentsFilter(page, pageSize, client_id,filter?.status, filter?.client, filter?.gateway, filter?.card_type, filter?.payment_status, filter?.timezone, filter?.dates?.[0], searchTexts, filter?.dates?.[1]);
      setPayments(
        Object.entries(data.payments ?? {}).flatMap(
          ([key, value]: any) =>
            value.map((transaction: any) => ({
              ...transaction,
              payment_id: key,
              expanded: false,
              all_data: []
            }))
        )
      );
      setTotalPage(data.total_pages);
      setTotalItems(data.total_items);
      setCurrentPage(data.current_page);
    } catch {
      toast.error("Failed to fetch payments");
    } finally {
      setIsPaymentLoading(false);
      setLoadingTransaction(false);
    }
  };

  useEffect(() => { if (page !== 0) filterData(); }, [page, curretClient, pageSize, value, clearClicked]);
  useEffect(() => { setPage(1); setPageSize(50); setValue((v) => !v); }, [paymentType, filter?.status, searchTexts]);

  const onClearClick = () => setClearClick((prev) => prev + 1);
  const isAllDataReady = Object.values(loadingState).every((v) => v === false);

  return (
    <div className="txn-root"> 
      <PaymentTable
        pageSize={pageSize} setPageSize={setPageSize}
        tableData={payments} fetchPayments={filterData}
        isLoading={isPaymentLoading} page={page} setPage={setPage}
        totalpage={totalpage} totalItems={totalItems} currentPage={currentPage}
        clients={clients} allGateways={allGateways} allCardType={allCardType}
        curretClient={curretClient} setCurrentClient={setCurrentClient}
        roleData={singleRoleData} filterData={filterData}
        filter={filter} setFilter={setFilter}
        setClearClick={onClearClick} onValueChange={serchboxValueChange}
        setLocalFilters={setLocalFilters} localFilters={localFilters}
        isAllDataReady={isAllDataReady} searchTexts={searchTexts} client_id={client_id}
      />
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

        .txn-root {
          font-family: 'Plus Jakarta Sans', sans-serif;
          display: flex;
          flex-direction: column;
          gap: 20px;
        }
        
        @media (max-width: 600px) {
          .txn-root { padding: 14px; gap: 14px; }
        }
      `}</style>
    </div>
  );
};

export default Payments;